export default "__VITE_ASSET__25783eea__"